import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './PhoneInput.css';
import React, { useEffect, useState } from 'react';
import { SitecoreContextReactContext } from '../../../../../../../utils/SitecoreContextReactContext';
import Select from 'react-select';
import { canUseDOM, get } from '../../../../../../../utils';
export var PhoneInput = function PhoneInput(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropOpened = _useState2[0],
    setDropOpened = _useState2[1];
  var rawCountryItems = props.countryItems.map(function (country, index) {
    return {
      label: /*#__PURE__*/React.createElement("span", {
        className: "select-item"
      }, country.flagSrc && country.flagSrc.length > 0 && /*#__PURE__*/React.createElement("img", {
        alt: country.code,
        className: "select-item__image",
        src: country.flagSrc
      }), ' ', /*#__PURE__*/React.createElement("span", {
        className: "select-item__text"
      }, country.text || '-')),
      listingLabel: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, country.countryName), " ", "(".concat(country.text || '-', ")")),
      value: get(country, 'value') || "".concat(index, "-"),
      code: get(country, 'code'),
      countryName: get(country, 'countryName')
    };
  });
  var handleDropMousedown = function handleDropMousedown() {
    setDropOpened(!dropOpened);
  };
  var handleDropTouchstart = function handleDropTouchstart(e) {};
  var getInitialCode = function getInitialCode() {
    var countryCode = '';
    if (canUseDOM) {
      var countryNameCookie = document.cookie.split(';').find(function (item) {
        return item.indexOf('user_country_code') > -1;
      });
      if (countryNameCookie) {
        var countryName = countryNameCookie.replace('user_country_code=', '').trim();
        countryCode = countryName !== 'undefined' ? countryName.replace(/\s/g, '') : '';
      }
    }
    var serverCountry = rawCountryItems.find(function (item) {
      return item.code === countryCode;
    }) || rawCountryItems[0];
    return serverCountry;
  };
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    initCode = _useState4[0],
    setinitCode = _useState4[1];
  useEffect(function () {
    var defaultCode = getInitialCode();
    props.onChange({
      code: defaultCode.value,
      number: props.value.number,
      valid: true
    });
    setinitCode(defaultCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (props.code && props.code.length) {
      var validCode = props.code.includes('+') ? props.code : "+".concat(props.code);
      var langItem = rawCountryItems.find(function (_ref) {
        var value = _ref.value;
        return value == validCode;
      });
      langItem && setinitCode(langItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.code]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: "".concat(rtl ? rtlStyles : ltrStyles, " ").concat(styles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-wrapper ".concat(dropOpened ? 'input-wrapper--opened' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-wrapper",
    onMouseDown: handleDropMousedown,
    onTouchStart: handleDropTouchstart
  }, /*#__PURE__*/React.createElement(Select, {
    isSearchable: true,
    classNamePrefix: "select-dropdown",
    className: "react-custom-select",
    name: "code-".concat(props.name),
    options: rawCountryItems,
    onChange: function onChange(val) {
      return val && props.onChange({
        code: val.value,
        number: props.value.number,
        valid: true
      });
    },
    value: initCode,
    defaultValue: initCode,
    isRtl: rtl,
    formatOptionLabel: function formatOptionLabel(option, _ref2) {
      var context = _ref2.context;
      return context === 'menu' ? option.listingLabel : option.label;
    },
    required: props.required
  })), /*#__PURE__*/React.createElement("input", {
    className: "input-text-primary ".concat(props.phoneInputClass || ''),
    type: "text",
    value: props.value.number,
    onBlur: function onBlur(e) {
      return props.onBlur && props.onBlur({
        code: props.value.code,
        number: e.currentTarget.value,
        valid: e.currentTarget.validity.valid
      });
    },
    onChange: function onChange(e) {
      if (/[^0-9\s]+$/.test(e.target.value)) return;
      props.onChange({
        code: props.value.code,
        number: e.currentTarget.value,
        valid: e.currentTarget.validity.valid
      });
    },
    placeholder: props.placeholder,
    maxLength: props.maxLength,
    minLength: props.minLength,
    name: props.name,
    id: props.itemId,
    required: props.required
  })));
};
var styles = "sxmlsxq";
var rtlStyles = "r3pgwi3";
var ltrStyles = "lw7up2x";